// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Icon-Icon-module__Icon";
var _2 = "webpack-components-core-Icon-Icon-module__bold";
var _3 = "webpack-components-core-Icon-Icon-module__danger";
var _4 = "webpack-components-core-Icon-Icon-module__inverse";
var _5 = "webpack-components-core-Icon-Icon-module__inverse-danger";
var _6 = "webpack-components-core-Icon-Icon-module__inverse-neutral";
var _7 = "webpack-components-core-Icon-Icon-module__inverse-primary";
var _8 = "webpack-components-core-Icon-Icon-module__inverse-success";
var _9 = "webpack-components-core-Icon-Icon-module__inverse-warning";
var _a = "webpack-components-core-Icon-Icon-module__inverseWrapper";
var _b = "webpack-components-core-Icon-Icon-module__lg";
var _c = "webpack-components-core-Icon-Icon-module__md";
var _d = "webpack-components-core-Icon-Icon-module__neutral";
var _e = "webpack-components-core-Icon-Icon-module__normal";
var _f = "webpack-components-core-Icon-Icon-module__primary";
var _10 = "webpack-components-core-Icon-Icon-module__sm";
var _11 = "webpack-components-core-Icon-Icon-module__success";
var _12 = "webpack-components-core-Icon-Icon-module__warning";
var _13 = "webpack-components-core-Icon-Icon-module__xl";
var _14 = "webpack-components-core-Icon-Icon-module__xs";
var _15 = "webpack-components-core-Icon-Icon-module__xxl";
var _16 = "webpack-components-core-Icon-Icon-module__xxxl";
export { _1 as "Icon", _2 as "bold", _3 as "danger", _4 as "inverse", _5 as "inverse-danger", _6 as "inverse-neutral", _7 as "inverse-primary", _8 as "inverse-success", _9 as "inverse-warning", _a as "inverseWrapper", _b as "lg", _c as "md", _d as "neutral", _e as "normal", _f as "primary", _10 as "sm", _11 as "success", _12 as "warning", _13 as "xl", _14 as "xs", _15 as "xxl", _16 as "xxxl" }
